import { ThunkDispatch, ThunkResult } from '.';
import { analyze, createUser, notify, updateUser } from './api';

import { Action } from 'redux';
import { ChallengeResult } from './challenge';

// Types

export interface AuthState {
  authenticated: boolean
  userName: string
}

// Initialization

const initialState: AuthState = {
  authenticated: false,
  userName: "",
}

// Action Definition

export const AUTH_LOGIN = 'auth/LOGIN'
export const AUTH_LOGOUT = 'auth/LOGOUT'

export interface AuthLoginAction extends Action {
  type: typeof AUTH_LOGIN,
  userName: string
}

export interface AuthLogoutAction extends Action {
  type: typeof AUTH_LOGOUT,
}

// Reducer 

export default (state = initialState, action: Action) => {
  switch (action.type) {
    case AUTH_LOGIN:
      return {
        ...state,
        authenticated: true,
        userName: (action as AuthLoginAction).userName
      }

    case AUTH_LOGOUT:
      return {
        ...state,
        authenticated: false,
        userName: "",
      }

    default:
      return state
  }
}

// Action Creators

export const login = (userName: string): ThunkResult<{ analyzePromise: Promise<any>, challengePromise: Promise<ChallengeResult> }> =>
  (dispatch: ThunkDispatch) => {
    let { analyzePromise, challengePromise } = dispatch(analyze({
      identificationData: {
        userName
      },
      eventDataList: {
        eventData: {
          eventType: "SESSION_SIGNIN",
          // force all login temporarily
          /*clientDefinedAttributeList: {
            fact: {
              name: "FORCE WORKFLOW",
              value: "Question",
              dataType: "STRING"
            }
          }*/
        }
      }
    }))

    analyzePromise = analyzePromise.then((analyzeResponse: any) => {
      /*let { soapResponse } = analyzeResponse
      try {
        let {} = soapResponse.riskResult.triggeredRule.actionCode
        let {} = soapResponse.identificationData.userStatus
      }
      catch (err) {
        throw new Error("Unknown SOAP response")
      }*/

      dispatch({
        type: AUTH_LOGIN,
        userName,
      } as AuthLoginAction)

      return analyzeResponse
    })

    return { analyzePromise, challengePromise };
  }

export const loginFailure = (userName: string) =>
  (dispatch: ThunkDispatch) =>
    dispatch(notify({
      identificationData: {
        userName
      },
      eventDataList: {
        eventData: {
          eventType: 'FAILED_LOGIN_ATTEMPT',
          authenticationLevel: {
            level: "500"
          }
        }
      }
    }))

export const logout = (): ThunkResult<Promise<void>> =>
  (dispatch: ThunkDispatch) => {
    dispatch({
      type: AUTH_LOGOUT,
    } as AuthLogoutAction)
    return Promise.resolve()
  }

export const newUser = (userName: string) =>
  (dispatch: ThunkDispatch) => {
    let args = {
      actionTypeList: {
        genericActionTypes: "SET_USER_STATUS"
      },
      identificationData: {
        userName,
        userStatus: "UNVERIFIED",
      }
    }

    return dispatch(createUser(args))
      .catch((error: Error) => {
        console.error(error)
        throw error
      })
  }

export const unlockUser = (userName: string) =>
  (dispatch: ThunkDispatch) => {
    let args = {
      actionTypeList: {
        genericActionTypes: "SET_USER_STATUS"
      },
      identificationData: {
        userName,
        userStatus: "VERIFIED",
      }
    }

    return dispatch(updateUser(args))
      .catch((error: Error) => {
        console.error(error)
        throw error
      })
  }

export const deleteUser = (userName: string) =>
  (dispatch: ThunkDispatch) => {
    let args = {
      actionTypeList: {
        genericActionTypes: "SET_USER_STATUS"
      },
      identificationData: {
        userName,
        userStatus: "DELETE",
      }
    }

    return dispatch(updateUser(args))
      .catch((error: Error) => {
        console.error(error)
        throw error
      })
  }